import { ref, unref, watchEffect } from '@vue/composition-api'
import TicketService from '@/services/modules/TicketService'
import { EventBus } from '@/utils/EventBus'

export default function useTicketMensagens(ticketId) {
  const mensagens = ref([])

  async function getMensagens() {
    const data = await TicketService.getMensagens(unref(ticketId))
    mensagens.value = data.reverse()
  }

  function resetData() {
    mensagens.value = []
  }

  watchEffect(async () => {
    if (unref(ticketId) === 0) {
      resetData()
    } else {
      await getMensagens()
    }
  })

  EventBus.$on('fetch-ticket-messages', getMensagens)

  return {
    mensagens,
    getMensagens,
  }
}
